import React from 'react';
import './GeneralQuestions.css';
import { Container } from 'react-bootstrap';

const GeneralQuestion = () => (
  <div className="section">
    <h2>General Questions</h2> <br/>
    <div className="qa">
      <h3>What is QuickLearn?</h3> 
      <p>QuickLearn is an online platform that provides access to a wide range of educational resources, including textbooks, notes, and previous year papers, across various academic disciplines and levels.</p>
    </div>
    <div className="qa"> <br/>
      <h3>How can I access the resources on QuickLearn?</h3>
      <p>Accessing resources on QuickLearn is easy! Simply browse our website and use the search bar to find the materials you need. You can download resources directly from the site.</p>
    </div>
    <div className="qa"><br/>
      <h3>Is QuickLearn free to use?</h3>
      <p>Yes, QuickLearn is completely free to use. We believe in making education accessible to everyone, regardless of financial constraints.</p>
    </div>
  </div>
);

const AccountAndProfile = () => (
  <div className="section">
    <h2>Account and Profile</h2> 
    <div className="qa"> <br/>
      <h3>Do I need to create an account to use QuickLearn?</h3>
      <p>No, creating an account is not required to access resources on QuickLearn. However, registering for an account allows you to become a member of our community.</p>
    </div>
    <div className="qa">  <br/>
      <h3>How do I create an account?</h3> 
      <p>To create an account on QuickLearn, click on the "Sign Up" or "Register" button on the top right corner of the website. Fill in the required information and follow the prompts to create your account.</p>
    </div>
    <div className="qa"> <br/>
      <h3>I forgot my password. How do I reset it?</h3>
      <p>If you forgot your password, you can reset it by clicking on the "Forgot Password" link on the login page. Follow the instructions provided to reset your password.</p>
    </div>
  </div>
);

const ContentAndResources = () => (
  <div className="section">
    <h2>Content and Resources</h2> <br/>
    <div className="qa">
      <h3>What types of educational resources are available on QuickLearn?</h3>
      <p>QuickLearn offers a variety of resources, including textbooks, lecture notes, study guides, and previous year papers, covering subjects such as Mathematics, Science, Engineering, Humanities, and more.</p>
    </div>
    <div className="qa"> <br/>
      <h3>Are the resources on QuickLearn updated regularly?</h3>
      <p>Yes, we strive to keep our resource library up-to-date with the latest materials. However, we also rely on user contributions, so if you have any relevant materials to share, feel free to upload them to our platform.</p>
    </div>
    <div className="qa"> <br/>
      <h3>Can I contribute my own educational materials to QuickLearn?</h3>
      <p>Absolutely! We welcome contributions from educators, students, and subject matter experts. If you have study materials, lecture notes, or other educational resources to share, you can upload them to QuickLearn to help others.</p>
    </div>
  </div>
);

const GeneralQuestions = () => (
  <div className="app">
    <Container style={{textAlign:"justify"}}>
        <GeneralQuestion />
        <AccountAndProfile />
        <ContentAndResources />
    </Container>
  </div>
);

export default GeneralQuestions;
